import { useSelector, useDispatch } from "react-redux";
import { devicesActions } from "../store";
import { useEffect } from "react";
import { map } from "./map";

let lastRun = new Date().getTime();
let first_time = true;

const LivePositions = () => {
    const devices = useSelector((state) => state.devices.items);
    const positions = Object.values(useSelector((state) => state.positions.items));
    const selectedId = useSelector((state) => state.devices.selectedId);

    const dispatch = useDispatch();

    const createFeature = (position, devices, selectedId, is_many_devices) => {
        const device = devices[position.deviceId] || {};
        if (is_many_devices) {
            const color = { offline: "rgb(255, 100, 100)", online: "rgb(100, 255, 100)", unknown: "rgb(38, 60, 153)" };

            return {
                id: position.deviceId,
                position: [position.longitude, position.latitude],
                name: is_many_devices ? "" : (device && device.name) || "خودرو پیدا نشد",
                priority: (device && (device.id === selectedId ? 1 : 0)) || 0,
                size: device.id === selectedId ? 11.25 : 7.5,
                color: device.id === selectedId ? "#ffcc12" : color[(device && device.status) || "unknown"],
            };
        } else
            return {
                id: position.deviceId,
                position: [position.longitude, position.latitude],
                name: is_many_devices ? "" : (device && device.name) || "خودرو پیدا نشد",
                icon: (device && device.status) || "unknown",
                priority: (device && (device.id === selectedId ? 1 : 0)) || 0,
                size: device.id === selectedId ? 1.3 : 1,
            };
    };

    const update = (devices, positions, selectedId, is_many_devices) => {
        const devicesSource = map.getSource("devices" + (is_many_devices ? "-many" : ""));

        if (!positions.length) return;

        if (!devicesSource) return;

        devicesSource.setData({
            type: "FeatureCollection",
            features: positions.map((position) => {
                const lat = position.latitude - 0.00009;
                const lon = position.longitude - 0.00009;

                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: [lon > 90 ? 90 : lon < -90 ? -90 : lon, lat > 90 ? 90 : lat < -90 ? -90 : lat],
                    },
                    properties: createFeature(position, devices, selectedId, is_many_devices),
                };
            }),
        });
    };

    useEffect(() => {
        const devices_length = Object.keys(devices).length;
        if (devices_length !== 0) {
            const is_many_devices = devices_length > 10;

            if (first_time) {
                if (!positions.length) return;
                if (positions.length === 1) {
                    dispatch(devicesActions.select(positions[0].deviceId));
                    map.flyTo({ center: [positions[0].longitude, positions[0].latitude], zoom: 14 });
                }
                first_time = false;

                update(devices, positions, selectedId, is_many_devices);
            }

            if (new Date().getTime() - lastRun > (is_many_devices ? 2000 : 600)) {
                update(devices, positions, selectedId, is_many_devices);
                lastRun = new Date().getTime();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [devices, positions, selectedId]);

    useEffect(() => {
        const devices_length = Object.keys(devices).length;
        if (devices_length !== 0) {
            const is_many_devices = devices_length > 10;
            update(devices, positions, selectedId, is_many_devices);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId]);

    return [];
};

export default LivePositions;
